module.exports = __webpack_public_path__ + "static/media/captivating-2.33de0973.png";